document.addEventListener('DOMContentLoaded', function() {
    var pathname = window.location.pathname;

    if (pathname.includes('/en-uae')) {
        document.cookie = "region=uae; path=/";
    } else if (pathname.includes('/en-lben')) {
        document.cookie = "region=lben; path=/";
    }
});

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}
